import React from 'react';
import {required, TextInput} from 'react-admin';
import {Typography} from "@material-ui/core";

const LogicInput = () => (
        <div className="">
            <Typography variant="paragraph">
                URL for redirects by platforms
            </Typography>
            <TextInput
                source="logic.logic_web"
                label="Primary URL (default)"
                fullWidth
                validate={required()}
                helperText="This will be used as the default web URL (Web)"
            />
            <TextInput  label="Android Url" source="logic.logic_android" fullWidth/>
            <TextInput label="iOs Url" source="logic.logic_ios" fullWidth/>
        </div>
);

export default LogicInput;